import React from 'react'
import { Input } from 'antd'
import { RecepientToSend } from 'types/event/eventStep5'

interface AgeRecepientProps {
  recepientPayload: RecepientToSend | undefined
  setRecepientPayload: React.Dispatch<React.SetStateAction<RecepientToSend>>
}

const AgeRecepient: React.FC<AgeRecepientProps> = ({
  recepientPayload,
  setRecepientPayload,
}) => {
  return (
    <div className="h-13 scroller">
      <div className="mt-10px flex align-center justify-between gap-10px">
        <div className="w-50p">
          <label className="input-label">Minimum</label>
          <div className="flex gap-10px align-center justify-between">
            <div className="flex-1">
              <Input
                type="number"
                className="custom-input-field"
                placeholder="0"
                value={recepientPayload ? recepientPayload.minAge : 0}
                onChange={e =>
                  setRecepientPayload({
                    ...recepientPayload,
                    minAge: Number(e.target.value),
                  })
                }
                onWheel={e => e.currentTarget.blur()}
              />
            </div>
            <p className="w-20p">y.o</p>
          </div>
        </div>
        <div className="w-50p">
          <label className="input-label">Maximum</label>
          <div className="flex gap-10px align-center justify-between">
            <div className="flex-1">
              <Input
                type="number"
                className="custom-input-field"
                placeholder="0"
                value={recepientPayload ? recepientPayload.maxAge : 0}
                onChange={e =>
                  setRecepientPayload({
                    ...recepientPayload,
                    maxAge: Number(e.target.value),
                  })
                }
                onWheel={e => e.currentTarget.blur()}
              />
            </div>
            <p className="">y.o</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AgeRecepient
